import React, { Component } from 'react'
import { extendObservable, toJS } from 'mobx'
import { Dropdown } from '@components/Autocomplete'
import { observer, inject } from 'mobx-react'
import Button from '@components/Button'
import Delete from '@components/Icon/Delete'
import map from 'lodash/map'

const colors = {
  black: '#33344A',
  dark_blue: '#202A41',
  light_blue: '#67B0E7',
  lighter_blue: '#DDEDF9',
  ligther_blue2: '#99C8EC',
  blue3: '#2A4261',
  medium_blue: '#429ADC',
  blue: '#3A86BF',
  red: '#FF5858',
  red2: '#FF4949',
  green: '#39AC57',
  green2: '#67D158',
  orange: '#FF6D2A',
  orange2: '#FFB049',
  orange3: '#FD8249',
  gray: '#D7DCE4',
  gray2: '#858485',
  gray3: '#BCC3CF',
  gray4: '#F0F0F0',
  gray5: '#E8E8E8',
  dark_gray: '#7E8DA2',
  medium_gray: '#B6C0CD',
  light_gray: '#F1F1F8',
  lighter_gray: '#F9F9FC',
  white: '#FFFFFF',
  dirty_white: '#FAFAFC',
  lighter_red: '#FF4F4F',
  yellow_light: '#FEF8F0',
  yellow_dark: '#FCE5C8',
  floral_white: '#FFF7ED',
  gold: '#EEB355'
}

class EditActionsModal extends Component {
  static defaultProps = {
    hideButtons: true
  }
  constructor (props) {
    super(props)
    extendObservable(this, {
      actions: toJS(this.props.store._actions)
    })
  }
  render () {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <h3>Edit actions</h3>
          <Button
            onClick={() => this.actions.push({ name: '', color: '#FFFFFF' })}
          >
            Add new
          </Button>
        </div>
        <div>
          {map(this.actions, (a, index) => (
            <div
              key={a.id}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <input
                value={a.name}
                style={{ width: '45%', marginRight: 15, marginBottom: 15 }}
                onChange={e => (a.name = e.target.value)}
              />
              <div style={{ width: '50%', marginRight: 15 }}>
                <Dropdown
                  selectedItem={a.color}
                  color={a.color}
                  options={Object.keys(colors)}
                  onChange={val => (a.color = colors[val])}
                  itemToString={i => (
                    <div
                      style={{
                        background: colors[i],
                        marginTop: -8,
                        marginBottom: -8,
                        marginRight: -8,
                        marginLeft: -8,
                        padding: 10
                      }}
                    >
                      {a.name}
                    </div>
                  )}
                />
              </div>
              <Button onClick={() => this.actions.splice(index, 1)}>
                <Delete />
              </Button>
            </div>
          ))}
          <div>
            <Button
              onClick={async () => {
                await this.props.store.saveActions(this.actions)
                this.props.modalStore.close()
              }}
            >
              Save
            </Button>
            <Button onClick={() => this.props.modalStore.close()}>Close</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default inject('modalStore')(observer(EditActionsModal))
